import { createStore } from "owa-satcheljs";
import type MailLayoutStore from "./schema/MailLayoutStore";
import { type AnimationPreference } from "owa-outlook-service-option-store";

const mailLayoutStore: MailLayoutStore = {
    clientReadingPanePosition: null,
    showReadingPane: false,
    showListPane: true,
    showFolderPane: true,
    showFolderPaneAsTransientOverlay: false,
    showAllAccountsNode: true,
    showFolderPaneOverlayAsBlocking: false,
    useSingleLineMessageListWithRightReadingPane: true,
    animationPreference: 0,
    shouldAnimate: false,
    senderColumnWidth: null,
    subjectColumnWidth: null,
    receivedColumnWidth: null,
    sortedContentColumnWidth: null,
    favoritesPaneHeight: null,
};

export const getStore: () => MailLayoutStore = createStore<MailLayoutStore>("maillayout", mailLayoutStore);
